import _ from "lodash";
import { queryWaterProviderWithDocs } from "./api";
import { PROVIDER_FIELDS, QUERY_URL_AND } from "./constants";
import { getProviders } from "./fetchProviders";
import { WaterProvider } from "./types";

export const fetchProviderByIds = async (adminIds: string[]): Promise<WaterProvider[]> => {
    const valid = adminIds?.filter(d => d != null && d?.toString()?.trim() !== "");
    if (!valid?.length) return [];

    const providers = getProviders();
    if (providers?.length > 0) {
        const adminIdMap = valid.reduce((prev, cur) => {
            prev[cur] = 1;
            return prev;
        }, {});

        return providers?.filter(d => adminIdMap[d.adminId] === 1);
    }

    const query = _.join(valid, " OR ");
    const solrQuery = _.join(
        ["q=*:*", "rows=1000", `fq=pure_strings_admin_id:(${query})`, `fl=${PROVIDER_FIELDS}`],
        QUERY_URL_AND
    );

    const _providers = await queryWaterProviderWithDocs(solrQuery);

    return _providers;
};
